enum InputNames {
  companyName = 'companyName',
  firstName = 'firstName',
  lastName = 'lastName',
  phone1 = 'phone1',
  source = 'source',
  email = 'email',
  street = 'street',
  zipCode = 'zipCode',
  city = 'city'
}

export default InputNames
